import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import PubSub from 'pubsub-js';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';
import Auth from '../services/auth';
import RefreshIcon from '@material-ui/icons/Refresh';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import CircularProgress from '@material-ui/core/CircularProgress';
import DatePicker from 'react-datepicker';
import qs from 'qs';
import ReactGA from 'react-ga4';
import 'react-datepicker/dist/react-datepicker.css';
import WorklistDataAccess from '../services/workListDataAccess';

const workListDataAccess = new WorklistDataAccess();
const auth = new Auth();

const styles = theme => ({
    root: {
        flexGrow: 1
    },
    card: {
        minWidth: 275,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        marginBottom: 16,
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    pendingCodingCard: {
        borderLeft: `8px solid #F08080`
    },
    physicianQueryCard: {
        borderLeft: `8px solid #FF3399`
    },
    incompleteCard: {
        //display: 'flex',
        //flexDirection: 'row',
        //flexWrap: 'wrap',
        //minWidth: '400px',
        //maxWidth: '1200px',
        borderLeft: '8px solid #F40013'
    }, cardBlue: {
        //minWidth: 240,
        borderLeft: '8px solid #31a7ff'
    }
    , cardGreen: {
        //minWidth: 240,
        borderLeft: '8px solid #17c92c'
    }, cardGrey: {
        //minWidth: 240,
        borderLeft: '8px solid #8c8c8c'
    }, cardRed: {
        //minWidth: 240,
        borderLeft: '8px solid red'
    },
    cardYellow:{
        borderLeft: '8px solid #F5F545'
    },
    tatCard: {
        height: 200
    },
    tatCardReason: {
        height: 75
    },
    dateSelection: {
        marginLeft: theme.spacing(1)
    },
    button: {
        margin: theme.spacing(1),
    },
    cardTitle: {
        fontSize: '1.1rem'
    },
    cardSubTitle: {
        fontSize: '0.8rem'
    },
    dateWrapper: {
        display: 'inline-block'
    }
});


class Dashboard extends Component {
    displayName = Dashboard.name

    onViewWorkList = (tickler, listType) => {

        tickler = String(tickler);

        ReactGA.event({
            action: 'DashboardFolderView',
            category: tickler,
            label: auth.getUserType()
        });

        if (listType == "Worklist") {
            sessionStorage.setItem('tickler', tickler);
            this.props.history.push('/worklist', { tickler: tickler })
        }
        else if (listType == "IVlist") {
            this.props.history.push('/ivlist')
        }
    }

    onViewReports = (path, overrideArchive, dateType) => {

        var status = [];
        status.push(path);

        ReactGA.event({
            action: 'DashboardFolderView',
            category: path,
            label: auth.getUserType()
        });

        if (!this.state.includeArchive && !overrideArchive) {
            status.push("NotArchived");
        }

        let queryString = {
            'status': status
        };

        if (dateType) {
            queryString.dateType = dateType;
        }

        this.props.history.push(`/reports/?${qs.stringify(queryString)}`);

    }

    handleToDateChange = (date) => {

        this.setState({ toDate: date });
        if (moment(date).isValid()) {
            auth.setToDate(moment(date).format("MM/DD/YYYY"));
            this.setState({ toDateInput: auth.getToDate() });
            this.loadWorklistSummary();
        }
    }
    handleFromDateChange = (date) => {

        this.setState({ fromDate: date });
        if (moment(date).isValid()) {
            auth.setFromDate(moment(date).format("MM/DD/YYYY"));
            this.setState({ fromDateInput: auth.getFromDate() });
            this.loadWorklistSummary();
        }

    }

    onDateFilterChange = (e, filterName) => {

        this.setState({ [filterName]: e.target.value });

        if (moment(e.target.value).isValid()) {
            if (filterName === "toDateInput") {
                auth.setToDate(e.target.value);
            }

            if (filterName === "fromDateInput") {
                auth.setFromDate(e.target.value);
            }

            this.loadWorklistSummary();
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            workListSummary: [],
            codedForDownload: 0,
            isLoading: true,
            toDate: moment(auth.getToDate(), 'MM/DD/YYYY'),
            fromDate: moment(auth.getFromDate(), 'MM/DD/YYYY'),
            fromDateInput: auth.getFromDate(),
            toDateInput: auth.getToDate(),
            includeArchive: (auth.getUserType() === "Dictator" || auth.getUserType() === "Physician Office Employee")
        }

    }

    getDummyZeroData() {
        let dummyData = [{"Tickler":1,"Label":"AR Collector","Description":"","Show":true,"Count":0,"ListType":"Worklist","Color":"Green"},{"Tickler":2,"Label":"AR Collector - Priority","Description":"","Show":true,"Count":0,"ListType":"Worklist","Color":"Red"},{"Tickler":3,"Label":"AR Collector - ALL","Description":"","Show":true,"Count":0,"ListType":"Worklist","Color":"Grey"},{"Tickler":4,"Label":"Patient Accounts","Description":"","Show":true,"Count":0,"ListType":"Worklist","Color":"Green"},{"Tickler":5,"Label":"Patient Accounts - Priority","Description":"","Show":true,"Count":0,"ListType":"Worklist","Color":"Red"},{"Tickler":9,"Label":"Patient Accounts - ALL","Description":"","Show":true,"Count":0,"ListType":"Worklist","Color":"Grey"},{"Tickler":6,"Label":"Insurance Verification","Description":"","Show":true,"Count":0,"ListType":"Worklist","Color":"Green"},{"Tickler":8,"Label":"Insurance Verification - Priority","Description":"","Show":true,"Count":0,"ListType":"Worklist","Color":"Red"},{"Tickler":7,"Label":"Insurance Verification - ALL","Description":"","Show":true,"Count":0,"ListType":"Worklist","Color":"Grey"},{"Tickler":10,"Label":"Supervisors","Description":"","Show":true,"Count":0,"ListType":"Worklist","Color":"Blue"},{"Tickler":11,"Label":"Payment Posting","Description":"","Show":true,"Count":0,"ListType":"Worklist","Color":"Blue"},{"Tickler":12,"Label":"Credits","Description":"","Show":true,"Count":0,"ListType":"Worklist","Color":"Blue"},{"Tickler":13,"Label":"Legacy AR","Description":"","Show":true,"Count":0,"ListType":"Worklist","Color":"Green"},{"Tickler":14,"Label":"Legacy AR - Priority","Description":"","Show":true,"Count":0,"ListType":"Worklist","Color":"Red"},{"Tickler":18,"Label":"Legacy AR - ALL","Description":"","Show":true,"Count":0,"ListType":"Worklist","Color":"Grey"},{"Tickler":15,"Label":"All","Description":"","Show":true,"Count":0,"ListType":"Worklist","Color":"Blue"},{"Tickler":16,"Label":"QA Queue","Description":"","Show":true,"Count":0,"ListType":"Worklist","Color":"Orange"}];
        return dummyData;
    }

    loadWorklistSummaryNoData() {
        var self = this;
        //self.setState({ isLoading: false });
        self.setState({ workListSummary: this.getDummyZeroData(), isLoading: false });
    }

    loadWorklistSummary() {
        var self = this;
        self.setState({ isLoading: true });

        workListDataAccess.getWorkinglistSummary().then(function (rs) {
            //console.log(rs);
            self.setState({ workListSummary: rs, isLoading: false });
        })
    }

    componentWillMount() {
        this.loadWorklistSummaryNoData();
        //this.loadWorklistSummary();
        //// This is where we subscribe this class to the 'GET FILES' subscription.
        //// once a publish event for 'GET FILES' has been fired, FileList.subscriber() will be triggered.
        //this.token = PubSub.subscribe('AccountChanged', this.loadWorklistSummary.bind(this));
    }
    componentWillUnmount() {
        PubSub.unsubscribe(this.token);
    }

    componentDidMount() {
        this.loadWorklistSummary();
        // This is where we subscribe this class to the 'GET FILES' subscription.
        // once a publish event for 'GET FILES' has been fired, FileList.subscriber() will be triggered.
        PubSub.publish('getClients');
        this.token = PubSub.subscribe('AccountChanged', this.loadWorklistSummary.bind(this));
    }

    getCardClassName(classes, color) {
        switch (color.toLowerCase()) {
            case "green":
                return classes.cardGreen;
            case "blue":
                return classes.cardBlue;
            case "yellow":
                return classes.cardYellow;
            case "red":
                return classes.cardRed;
            case "grey":
                return classes.cardGrey;
            default:
                return classes.cardGrey;
        }
    }

    render() {

        const { classes } = this.props;
        return (
            <div>
                <Grid className={classes.root} container spacing={4}>
                    <Grid item xs={12}>
                        <Card>
                            <CardContent>
                                <Grid className={classes.root} container spacing={4} justifyContent='space-between'>
                                    <Grid item>
                                        <Typography variant="h6">
                                            Dashboard
                                        </Typography>
                                        <Typography variant="subtitle1">
                                            Today is {moment().format('ddd, MMM Do')}
                                        </Typography>

                                    </Grid>
                                    <Grid item style={{ display: 'none' }}>
                                        <div className={classes.dateWrapper}>
                                            <DatePicker
                                                disabledKeyboardNavigation
                                                selected={this.state.fromDate}
                                                onChange={this.handleFromDateChange}
                                                customInput={
                                                    <div>
                                                        <TextField
                                                            className={classes.dateSelection}
                                                            id="fromDate"
                                                            label="From Date"
                                                            value={this.state.fromDateInput}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            onChange={(e) => this.onDateFilterChange(e, 'fromDateInput')}
                                                        />
                                                    </div>}
                                            />
                                        </div>
                                        <div className={classes.dateWrapper}>
                                            <DatePicker
                                                disabledKeyboardNavigation
                                                selected={this.state.toDate}
                                                onChange={this.handleToDateChange}
                                                customInput={
                                                    <div>
                                                        <TextField
                                                            className={classes.dateSelection}
                                                            id="toDate"
                                                            label="To Date"
                                                            value={this.state.toDateInput}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            onChange={(e) => this.onDateFilterChange(e, 'toDateInput')}
                                                        />
                                                    </div>}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item>
                                        <Tooltip title="Refresh" disableFocusListener={true}>
                                            <IconButton className={classes.button} aria-label="Refresh" onClick={(e) => {
                                                this.loadWorklistSummary();
                                                ReactGA.event({
                                                    action: 'Dashboard',
                                                    category: 'UserTriggeredRefresh',
                                                    label: auth.getUserType()
                                                });
                                            }}>
                                                <RefreshIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>

                    {this.state.workListSummary.map(option => {
                        return (option.Show) ?
                            < Grid key={option.Tickler} item xs={10} sm={6} md={4} lg={4} >
                                <Card className={this.getCardClassName(classes, option.Color)}>
                                    <CardContent>
                                        <Typography align="center" className={classes.cardTitle} variant="subtitle1" component="h2">{option.Label}</Typography>
                                        <Typography align="center" className={classes.cardSubTitle} variant="subtitle1" component="h4">{option.Description}</Typography>
                                        <span style={{ textDecoration: 'none', cursor: 'pointer' }} onClick={(e) => this.onViewWorkList(option.Tickler, option.ListType)}>
                                            <Typography align="center" variant="h4" component="h2">
                                                {this.state.isLoading && <CircularProgress />}
                                                {!this.state.isLoading && <span>{option.Count}</span>}
                                            </Typography>
                                        </span>
                                    </CardContent>
                                    <CardActions>
                                        <Button size="small" variant="outlined" color="primary" onClick={(e) => this.onViewWorkList(option.Tickler, option.ListType)}>View Worklist</Button>
                                    </CardActions>
                                </Card>
                            </Grid> : <span />
                    }
                    )}
                </Grid>
            </div>
        );
    }
}
export default withStyles(styles, { withTheme: true })(Dashboard);
